module.exports = __webpack_public_path__ + "static/media/29119.33c8c2c6.svg";